import mqtt from 'mqtt'

export default {
  install: (Vue) => {
    const mqttClient = mqtt.connect(process.env.VUE_APP_MQTT_URL, {
      username: 'test',
      password: 'test'
    })

    Object.defineProperty(Vue.prototype, '$mqtt', {
      value: mqttClient
    })
  }
}
